
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacy-policy/privacy-policy.lazy",
      function () {
        return require("private-next-pages/privacy-policy/privacy-policy.lazy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/privacy-policy/privacy-policy.lazy"])
      });
    }
  